import { render, staticRenderFns } from "./PaginaTitulo.vue?vue&type=template&id=110e31a2&scoped=true&"
import script from "./PaginaTitulo.vue?vue&type=script&lang=js&"
export * from "./PaginaTitulo.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTitulo.vue?vue&type=style&index=0&id=110e31a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e31a2",
  null
  
)

export default component.exports